import React from 'react';
import './PageHeaderBanner.css';

const PageHeaderBanner = ({ title, subtitle }) => {
  const bannerStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/header-banner-bg.png)`
  };

  return (
    <div className="page-header-banner w-full">
      <div className="banner-background" style={bannerStyle}>
        <div className="banner-content">
          {title && <h1 className="page-title">{title}</h1>}
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
        <div className="banner-decoration">
          <div className="banner-line banner-line-1"></div>
          <div className="banner-line banner-line-2"></div>
          <div className="banner-line banner-line-3"></div>
        </div>
      </div>
    </div>
  );
};

export default PageHeaderBanner;
